import { Navigate, Routes, Route, Outlet } from "react-router-dom";
import Layout from "./components/layout/Layout";
import SimpleLayout from "./components/layout/SimpleLayout";
import BaseInfoLayout from "./components/layout/BaseInfoLayout";
import Login from "./views/public/login/Login";
import Signin from "./views/public/signin/Signin";
import NotFound from "./views/public/404/NotFound";
import Dashboard from "./views/dashboard/Dashboard";
import DashboardMenus from "./views/sale/dashboardMenus/DashboardMenus";

import Accounting from "./views/accounting/Accounting";
import WareHouse from "./views/warehouse/WareHouse";
import Reports from "./views/reports/Reports";
import Notifications from "./views/notifications/Notifications";

import SaleUnits from "./views/sale/saleunit/SaleUnits";
import DiningTable from "./views/sale/diningtable/DiningTable";
import Pager from "./views/sale/pager/Pager";
import Printer from "./views/sale/printer/Printer";
import Profile from "./views/public/profile/Profile";
import Employee from "./views/sale/employee/Employee";
import CashDeskManage from "./views/sale/cashier/CashDeskManage";
import CashierManager from "./views/sale/cashier/CashierManager";
import CashDeskOffRecord from "./views/sale/cashier/CashDeskOffRecord";
import CashDeskPrinter from "./views/sale/cashier/CashDeskPrinter";
import PosDevices from "./views/sale/pos/PosDevices";
import PosBank from "./views/sale/pos/PosBank";
import ShipmentManager from "./views/sale/shipment/ShipmentManager";
import BranchSetting from "./views/sale/branchSetting/BranchSetting";
import DeliverySettlement from "./views/sale/delivery/DeliverySettlement";
import DeliveryPos from "./views/sale/delivery/DeliveryPos";
import SettlementOfAccounts from "./views/sale/delivery/SettlementOfAccounts";
import OrderManagment from "./views/sale/orderManagment/OrderManagment";
import snappManager from "./views/sale/snappManager/SnappManager";
import SnappOrders from "./views/sale/snappManager/SnappOrders";
import MenuCategoryManage from "./views/sale/menuCategoryManage/MenuCategoryManage";
import KitchenList from "./views/sale/kitchenList/KitchenList";
import DeliverySettlementDocument from "./views/sale/delivery/DeliverySettlementDocument";
import CashDeskPos from "./views/sale/cashier/CashDeskPos";
import Menu from "./views/sale/menuCategoryManage/Menu";
import EmployeeRole from "./views/sale/employee/EmployeeRole";
import SubmitOrder from "./views/sale/submitOrder/SubmitOrder";
import SaleUnitSnapSetting from "./views/sale/saleunit/SaleUnitSnapSetting";
import SnappServicePrice from "./views/sale/snappManager/SnappServicePrice";
import SnappMenuGroups from "./views/sale/snappManager/SnappMenuGroups";
import SnappMenus from "./views/sale/snappManager/SnappMenus";
import ToppingCategories from "./views/sale/snappManager/ToppingCategories";
import SnappToppings from "./views/sale/snappManager/SnappToppings";
import SnappMenuToppings from "./views/sale/snappManager/SnappMenuToppings";
import ServiceSetting from "./views/sale/serviceSetting/SerivceSetting";
import DeliveryOrder from "./views/sale/deliveryOrder/DeliveryOrder";
import DeliveryOrderList from "./views/sale/DeliveryPanel/DeliveryOrderList";
import SelectUnit from "./views/sale/menuCategoryManage/SelectUnit";
import BaseinfoHome from "./views/baseinfo/home/BaseinfoHome";
import ProductCategory from "./views/baseinfo/product/ProductCategory";
import UnitMeasurements from "./views/baseinfo/product/UnitMeasurements";
import Product from "./views/baseinfo/product/Product";

import Test from "./views/test/Test";
import SoftwareGuide from "./views/sale/SoftwareGuide/sale/SoftwareGuide";
import CallCenter from "./views/sale/callCenter/CallCenter";
import MerchantWallet from "./views/sale/merchantWallet/MerchantWallet";

import ReportHome from "./views/sale/reports/ReportHome";
import ProductReport from "./views/sale/reports/ProductReport";
import InvoiceReport from "./views/sale/reports/InvoiceReport";
import TotalSales from "./views/sale/reports/TotalSales";
import MerchantReport from "./views/sale/reports/MerchantReport";

import WaiterLayout from "./components/layout/WaiterLayout";
import WaiterHome from "./views/sale/WaiterPanel/WaiterHome";
import WaiterOrdering from "./views/sale/WaiterPanel/WaiterOrdering";

import ShippingLayout from "./components/layout/ShippingLayout";
import ShippingHome from "./views/sale/ShippingPanel/ShippingHome";
import ShippingDelivery from "./views/sale/ShippingPanel/ShippingDelivery";

import MerchantSalesReport from "./views/sale/SupportMerchant/MerchantSalesReport";

import KitchenHome from "./views/sale/KitchenPanel/KitchenHome";
import KitchenOrders from "./views/sale/KitchenPanel/KitchenOrders";
import KitchenLayout from "./components/layout/KitchenLayout";
import InvoiceReportItem from "./views/sale/reports/InvoiceReportItem";
import MerchantAddress from "./views/sale/merchantWallet/MerchantAddress";
import ReportCancellOrderSnapp from "./views/sale/reports/ReportCancellOrderSnapp";
import WareHouseLayout from "./components/layout/WareHouseLayout";
import CreateCategoryWarhouse from "./views/warehouse/CreateCategoryWarhouse";
import CreateWarHouse from "./views/warehouse/CreateWarHouse";
import Resturants from "./views/resturants/Resturants";
import DeliveryArchiveOrder from "./views/sale/DeliveryPanel/DeliveryArchiveOrder";
import ShippingArchiveDelivery from "./views/sale/ShippingPanel/ShippingArchiveDelivery";
import KitchenArchiveOrders from "./views/sale/KitchenPanel/KitchenArchiveOrders";
import DashboardLayout from "./components/layout/DashboardLayout";
import CategoryWarehouse from "./views/warehouse/category/CategoryWarehouse";
import CreateWareHouse from "./views/warehouse/create/CreateWareHouse";
import WareHousesLayout from "./components/layout/WareHousesLayout";
import RestaurantWarehouse from "./views/warehouse/RestaurantWarehouse";
import RestaurantWarehouseLayout from "./components/layout/RestaurantWarehouseLayout";
import SubCategoryWarehouse from "./views/warehouse/subcategory/SubCategoryWarehouse";
import BaseInfoRestaurantLayout from "./components/layout/BaseInfoRestaurantLayout";
import BaseInfoDashboard from "./views/baseinfo/restaurant/BaseInfoDashboard";
import BaseInfoProductCategory from "./views/baseinfo/restaurant/BaseInfoProductCategory";
import BaseInfoUnitMeasurements from "./views/baseinfo/restaurant/BaseInfoUnitMeasurements";
import BaseInfoProduct from "./views/baseinfo/restaurant/BaseInfoProduct";
import RestaurantAccounting from "./views/accounting/restaurant/RestaurantAccounting";
import AccountingRestaurantLayout from "./components/layout/AccountingRestaurantLayout";
import SupplierWarehouse from "./views/warehouse/supplier/SupplierWarehouse";
import SupplierProducts from "./views/warehouse/supplier/SupplierProducts";
import ProductWarehouse from "./views/warehouse/create/ProductWarehouse";
import ProductMeasurment from "./views/baseinfo/restaurant/ProductMeasurment";
import BaseInfoServices from "./views/baseinfo/restaurant/BaseInfoServices";
import PurchaseOrder from "./views/warehouse/purchase/PurchaseOrder";
import OrderItems from "./views/warehouse/purchase/OrderItems";
import CreateCategoryWarhouseTree from "./views/warehouse/CreateCategoryWarhouseTree";

function Routings() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/resturants" element={<Resturants />} />
      <Route path="/profile/:id" element={<Profile />} />
      <Route
        path="/:restaurantId/dashboard"
        element={<DashboardLayout component={Dashboard} />}
      />

      <Route path="/sale/:branchId" element={<Outlet />}>
        <Route
          exact
          path="/sale/:branchId"
          element={<Layout component={DashboardMenus} />}
        />
        <Route
          path="/sale/:branchId/saleunits"
          element={<Layout component={SaleUnits} />}
        />
        <Route
          path="/sale/:branchId/saleunits/snapSetting/:id"
          element={<Layout component={SaleUnitSnapSetting} />}
        />
        <Route
          path="/sale/:branchId/diningtable"
          element={<Layout component={DiningTable} />}
        />
        <Route
          path="/sale/:branchId/pager"
          element={<Layout component={Pager} />}
        />
        <Route
          path="/sale/:branchId/printer"
          element={<Layout component={Printer} />}
        />
        <Route
          path="/sale/:branchId/employee"
          element={<Layout component={Employee} />}
        />
        <Route
          path="/sale/:branchId/employee/employeeRole/:userId"
          element={<Layout component={EmployeeRole} />}
        />
        <Route
          path="/sale/:branchId/cashDeskManage"
          element={<Layout component={CashDeskManage} />}
        />
        <Route
          path="/sale/:branchId/cashier/cashierManager/:deskId"
          element={<Layout component={CashierManager} />}
        />
        <Route
          path="/sale/:branchId/cashier/deskRecord/:deskId"
          element={<Layout component={CashDeskOffRecord} />}
        />
        <Route
          path="/sale/:branchId/cashier/deskPrinter/:deskId"
          element={<Layout component={CashDeskPrinter} />}
        />
        <Route
          path="/sale/:branchId/cashier/deskPos/:deskId"
          element={<Layout component={CashDeskPos} />}
        />
        <Route
          path="/sale/:branchId/posDevices"
          element={<Layout component={PosDevices} />}
        />
        <Route
          path="/sale/:branchId/posDevices/banks"
          element={<Layout component={PosBank} />}
        />
        <Route
          path="/sale/:branchId/shipmentManger"
          element={<Layout component={ShipmentManager} />}
        />
        <Route
          path="/sale/:branchId/branchSetting"
          element={<Layout component={BranchSetting} />}
        />
        <Route
          path="/sale/:branchId/deliverySettlement"
          element={<Layout component={DeliverySettlement} />}
        />
        <Route
          path="/sale/:branchId/deliverySettlement/settlementOfAccounts/:userId"
          element={<Layout component={SettlementOfAccounts} />}
        />
        <Route
          path="/sale/:branchId/deliverySettlement/deliverySettlementDocument/:userId"
          element={<Layout component={DeliverySettlementDocument} />}
        />
        <Route
          path="/sale/:branchId/deliverySettlement/deliveryPos/:userId"
          element={<Layout component={DeliveryPos} />}
        />
        <Route
          path="/sale/:branchId/orderManagment"
          element={<Layout component={OrderManagment} />}
        />
        <Route
          path="/sale/:branchId/snappManager"
          element={<Layout component={snappManager} />}
        />
        <Route
          path="/sale/:branchId/snappManager/services"
          element={<Layout component={SnappServicePrice} />}
        />
        <Route
          path="/sale/:branchId/snappManager/SnappMenuGroups/:unitId"
          element={<Layout component={SnappMenuGroups} />}
        />
        <Route
          path="/sale/:branchId/snappManager/:unitId/:categoryId/SnappMenus"
          element={<Layout component={SnappMenus} />}
        />
        <Route
          path="/sale/:branchId/snappManager/ToppingCategories/:unitId"
          element={<Layout component={ToppingCategories} />}
        />
        <Route
          path="/sale/:branchId/snappManager/:unitId/SnappToppings/:categoryId"
          element={<Layout component={SnappToppings} />}
        />
        <Route
          path="/sale/:branchId/snappManager/:unitId/:categoryId/SnappMenuToppings/:menuId"
          element={<Layout component={SnappMenuToppings} />}
        />
        <Route
          path="/sale/:branchId/snappManager/Orders/:deskId"
          element={<Layout component={SnappOrders} />}
        />
        <Route
          path="/sale/:branchId/selectUnit"
          element={<Layout component={SelectUnit} />}
        />
        <Route
          path="/sale/:branchId/:unitId/menuCategoryManage/:parentId"
          element={<Layout component={MenuCategoryManage} />}
        />
        <Route
          path="/sale/:branchId/:unitId/menuCategoryManage/menu/:parentId"
          element={<Layout component={Menu} />}
        />
        <Route
          path="/sale/:branchId/kitchenList"
          element={<Layout component={KitchenList} />}
        />
        <Route
          path="/sale/:branchId/deliveryOrder"
          element={<SimpleLayout component={DeliveryOrder} />}
        />
        <Route
          path="/sale/:branchId/submitOrder/:cashDeskId"
          element={<SimpleLayout component={SubmitOrder} />}
        />
        <Route
          path="/sale/:branchId/serviceSetting"
          element={<Layout component={ServiceSetting} />}
        />
        <Route
          path="/sale/:branchId/callCenter"
          element={<Layout component={CallCenter} />}
        />
        <Route
          path="/sale/:branchId/merchantWallet"
          element={<Layout component={MerchantWallet} />}
        />
        <Route
          path="/sale/:branchId/merchantAddress/:id"
          element={<Layout component={MerchantAddress} />}
        />
        <Route
          path="/sale/:branchId/reports/home"
          element={<Layout component={ReportHome} />}
        />
        <Route
          path="/sale/:branchId/reports/product"
          element={<Layout component={ProductReport} />}
        />
        <Route
          path="/sale/:branchId/reports/invoice"
          element={<Layout component={InvoiceReport} />}
        />
        <Route
          path="/sale/:branchId/reports/sales"
          element={<Layout component={TotalSales} />}
        />
        <Route
          path="/sale/:branchId/reports/invoiceItem"
          element={<Layout component={InvoiceReportItem} />}
        />
        <Route
          path="/sale/:branchId/reports/merchant"
          element={<Layout component={MerchantReport} />}
        />
        <Route
          path="/sale/:branchId/support/invoices"
          element={<Layout component={MerchantSalesReport} />}
        />
      </Route>
      <Route
        path="/sale/:branchId/reports/cancellOrderSnapp"
        element={<Layout component={ReportCancellOrderSnapp} />}
      />

      <Route path="/signin" element={<Signin />} />

      <Route path="/accounting/" element={<Outlet />}>
        <Route
          exact
          path=":branchId"
          element={<Layout component={Accounting} />}
        />
        <Route
          exact
          path="restaurant/:restaurantId"
          element={
            <AccountingRestaurantLayout component={RestaurantAccounting} />
          }
        />
      </Route>

      <Route path="/wareHouse/" element={<Outlet />}>
        <Route
          path=":restaurantId/"
          element={
            <RestaurantWarehouseLayout component={RestaurantWarehouse} />
          }
        />
        <Route
          path=":restaurantId/:branchId"
          element={<WareHouseLayout component={WareHouse} />}
        />
        <Route
          path=":restaurantId/createCategoryWarehouse"
          element={<RestaurantWarehouseLayout component={CategoryWarehouse} />}
        />
        <Route
          path=":restaurantId/createCategoryWarehouse/:parentId"
          element={
            <RestaurantWarehouseLayout component={SubCategoryWarehouse} />
          }
        />
        <Route
          path=":restaurantId/:branchId/createCategoryWarehouse"
          element={<WareHouseLayout component={CreateCategoryWarhouse} />}
        />
        <Route
          path=":restaurantId/createWarehouse"
          element={<RestaurantWarehouseLayout component={CreateWareHouse} />}
        />
        <Route
          path=":restaurantId/productWarehouse/:id"
          element={<WareHousesLayout component={ProductWarehouse} />}
        />
        <Route
          path=":restaurantId/supplierWarehouse"
          element={<RestaurantWarehouseLayout component={SupplierWarehouse} />}
        />
        <Route
          path=":restaurantId/supplierProducts/:id"
          element={<WareHousesLayout component={SupplierProducts} />}
        />
        <Route
          path=":restaurantId/:branchId/createWarehouse"
          element={<WareHouseLayout component={CreateWarHouse} />}
        />
        <Route
          path=":restaurantId/purchaseOrder"
          element={<RestaurantWarehouseLayout component={PurchaseOrder} />}
        />
        <Route
          path=":restaurantId/createCategoryWarhouseTree"
          element={
            <RestaurantWarehouseLayout component={CreateCategoryWarhouseTree} />
          }
        />
        <Route
          path=":restaurantId/:supplierId/orderItems/:id"
          element={<RestaurantWarehouseLayout component={OrderItems} />}
        />
      </Route>

      <Route path="/reports" element={<Outlet />}>
        <Route exact path="/reports" element={<Layout component={Reports} />} />
      </Route>

      <Route path="/notification" element={<Outlet />}>
        <Route
          exact
          path="/notification"
          element={<Layout component={Notifications} />}
        />
      </Route>

      <Route path="/DeliveryPanel" element={<Outlet />}>
        <Route index element={<DeliveryOrderList />} />
        <Route path="archive" element={<DeliveryArchiveOrder />} />
      </Route>

      <Route path="/sale/:branchId/softwareGuide" element={<Outlet />}>
        <Route
          exact
          path="/sale/:branchId/softwareGuide"
          element={<Layout component={SoftwareGuide} />}
        />
      </Route>

      <Route path="*" element={<NotFound />} />

      <Route path="/baseinfo/" element={<Outlet />}>
        <Route
          path=":branchId"
          element={<BaseInfoLayout component={BaseinfoHome} />}
        />
        <Route
          path="restaurant/:restaurantId/"
          element={<BaseInfoRestaurantLayout component={BaseInfoDashboard} />}
        />
        <Route
          path=":branchId/productcategory"
          element={<BaseInfoLayout component={ProductCategory} />}
        />
        <Route
          path="restaurant/:restaurantId/productcategory"
          element={
            <BaseInfoRestaurantLayout component={BaseInfoProductCategory} />
          }
        />
        <Route
          path=":branchId/unitmeasurements"
          element={<BaseInfoLayout component={UnitMeasurements} />}
        />
        <Route
          path="restaurant/:restaurantId/unitmeasurements"
          element={
            <BaseInfoRestaurantLayout component={BaseInfoUnitMeasurements} />
          }
        />
        <Route
          path=":branchId/product"
          element={<BaseInfoLayout component={Product} />}
        />
        <Route
          path="restaurant/:restaurantId/product"
          element={<BaseInfoRestaurantLayout component={BaseInfoProduct} />}
        />
        <Route
          path="restaurant/:restaurantId/services"
          element={<BaseInfoRestaurantLayout component={BaseInfoServices} />}
        />
        <Route
          path="restaurant/:restaurantId/productMeasurment/:id"
          element={<BaseInfoRestaurantLayout component={ProductMeasurment} />}
        />
      </Route>
      <Route path="/waiterpanel" element={<Outlet />}>
        <Route
          exact
          path="/waiterpanel"
          element={<WaiterLayout component={WaiterHome} />}
        />
        <Route
          exact
          path="/waiterpanel/ordering/:branchId/:cashDeskId"
          element={<WaiterLayout component={WaiterOrdering} />}
        />
      </Route>

      <Route path="/shipping" element={<Outlet />}>
        <Route
          exact
          path="/shipping"
          element={<ShippingLayout component={ShippingHome} />}
        />
        <Route
          exact
          path="/shipping/:branchId/delivery"
          element={<ShippingLayout component={ShippingDelivery} />}
        />
        <Route
          exact
          path="/shipping/:branchId/archive-delivery"
          element={<ShippingLayout component={ShippingArchiveDelivery} />}
        />
      </Route>

      <Route path="/kitchen" element={<Outlet />}>
        <Route
          exact
          path="/kitchen"
          element={<KitchenLayout component={KitchenHome} />}
        />
        <Route
          exact
          path="/kitchen/:branchId/orders"
          element={<KitchenLayout component={KitchenOrders} />}
        />
        <Route
          exact
          path="/kitchen/:branchId/archive-orders"
          element={<KitchenLayout component={KitchenArchiveOrders} />}
        />
      </Route>

      <Route path="/test" element={<Test />} />
    </Routes>
  );
}

export default Routings;
